module.exports = __webpack_public_path__ + "static/media/family_01.68afaf2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_01.jpg
// module id = 5833
// module chunks = 0